import { render, staticRenderFns } from "./align-cell.vue?vue&type=template&id=78b0b2c8"
import script from "./align-cell.vue?vue&type=script&lang=js"
export * from "./align-cell.vue?vue&type=script&lang=js"
import style0 from "./align-cell.vue?vue&type=style&index=0&id=78b0b2c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../demeter/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports